"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("player-core/utils");
exports.createUUID = utils_1.createUUID;
var portal_position_1 = require("player-react-portal/build/portal-position");
exports.positionDropdown = portal_position_1.positionDropdown;
var player_react_portal_1 = require("player-react-portal");
exports.Portal = player_react_portal_1.Portal;
//# sourceMappingURL=__exports.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/predictive-search/build/__exports.js
// module id = 665
// module chunks = 0